import { customFetch } from 'utils/http';
import { ForbiddenError, HTTPResponseError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  email: string;
  password: string;
};

export const signin = async (params: Params) => {
  const { email, password } = params;

  const fetchURL = getM8AuthURL('signin');

  const body = new FormData();

  body.append('email', email);
  body.append('password', password);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 403) {
      throw new ForbiddenError();
    }

    throw new HTTPResponseError(response);
  }
};
